import { call, put, select, spawn, takeEvery } from 'redux-saga/effects';

import dynaFormsApi from '@elab/core/utils/dynaForms/api';
import dynaForms from '@elab/core/utils/dynaForms';
import { actions as globalActions } from '@elab/core/store/global';
import analytics from '@elab/core/utils/analytics';
import { actions as uiActions } from '@elab/core/store/ui';

import api from './api';
import actions from './actions';
import types from './types';

export function* doSubmit(newsletterSubscriptionDto, { selectors }) {
    const successRedirectLink = yield select(selectors.getSuccessRedirectLink);

    yield call(api.doNewsletterSubscription, newsletterSubscriptionDto);
    yield put(actions.setNewsletterSubscriptionInfo());

    if (successRedirectLink != null) {
        yield spawn(analytics.handleNewsletterSubscriptionConfirmation);
        yield put(globalActions.redirect(successRedirectLink));
    }
}

export function* showDisclaimer() {
    yield put(uiActions.showNewsletterDisclaimer());
}

function* watchSubmitSubscription() {
    yield spawn(analytics.handleNewsletterSubscriptionSubmit);
}

export default storeName => formId => [
    ...dynaForms.createSagaFor(
        storeName,
        dynaFormsApi.getFormMetadata(formId || storeName),
        doSubmit,
        null,
        true,
    ),
    takeEvery(types.FOCUS_FIELD, showDisclaimer),
    takeEvery(types.SUBMIT, watchSubmitSubscription),
];
